export function truncateDecimals(value: number, fractionDigits: number) {
  return parseFloat(value.toFixed(fractionDigits))
}
